import React from "react";
import Header from "../basic/Header";
import ContactUs from "../basic/contactUs";
import './EnggCourses.css';
import FundamentalsOfCProgramming from '../../images/cProgrammingImage.jpg';
import pythonForEverybody from '../../images/pythonForEverybody.jpg';
import machineLearning from '../../images/machineLearning.jpg';
import {Link} from "react-router-dom";
import CourseSectionHeader from "../basic/CourseSectionHeader";
class EnggCourses extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            program: 'Engineering Courses',
            courses: [
                {
                    title: "Fundamentals of C Programming",
                    subTitle: "Best for 1st and 2nd year graduates - All Branches",
                    imageUrl: FundamentalsOfCProgramming,
                    description: {
                        line1: "This course is aimed at mastering the C language through some theory classes along with hands on programming experience.",
                        line2: "By the end of this course, one will have great understanding of what does C programs comprise of and how they work and would be confident enough to write any kind of program using C."
                    },
                    duration: "30-40 hrs",
                    mode: "Online",
                    price: "Rs. 2000",
                    enrollmentUrl: "/Engineering_Courses/Fundamentals_Of_C_Programming",
                    benefits: [
                        { text: "Mastering the C Language fundamentals" },
                        { text: "Hands-on programming experience (Example programs and exercises)" },
                        { text: "Course Completion Certificate" },
                        { text: "Mentoring by Industry Experts" },
                    ]
                },
                {
                    title: "Machine Learning with hands on experience",
                    subTitle: "Best for 3rd and 4th year graduates - Preferably CS/Math background",
                    imageUrl: machineLearning,
                    description: {
                        line1: "This course is aimed at getting started with machine learning, making it easy to follow the core concepts and get comfortable with machine learning basics.",
                        line2: "By enrolling in this course, one will get an opportunity to work on 2 Machine Learning Projects under the guidance of industry experts followed by a self case study to solidify the learnings."
                    },
                    duration: "8 weeks (extendable w.r.t Case Study) ",
                    mode: "Online",
                    price: "Rs. 5000",
                    enrollmentUrl: "/Engineering_Courses/Machine_Learning_Fundamentals",
                    benefits: [
                        { text: "Specially designed to master the core concepts of Machine Learning" },
                        { text: "Frequent Topic-wise Test for your cognitive enhancements" },
                        { text: "Hands-on experience in building Machine Learning models and tuning them for optimizations" },
                        { text: "Live Doubt Support and Live mentor support" },
                    ]
                },
                {
                    title: "Python for Everybody - Basic Python",
                    subTitle: "Best for 1st and 2nd year graduates - All Branches",
                    imageUrl: pythonForEverybody,
                    description: {
                        line1: "This course aims to teach everyone the basics of programming computers using Python. We cover the basics of how one constructs a program from a series of simple instructions in Python.",
                        line2: "Once a student completes this course, they will be ready to take more advanced programming courses. This course covers Python 3."
                    },
                    duration: "25-30 hrs",
                    mode: "Online",
                    price: "Rs. 2000",
                    enrollmentUrl: "/Engineering_Courses/PythonForEverybody_Basic",
                    benefits: [
                        { text: "Mastering the Python Syntax & Semantics" },
                        { text: "Utilize core programming tools such as functions and loops" },
                        { text: "Hands-on programming experience (Example programs and exercises)" },
                        { text: "Course Completion Certificate" },
                        { text: "Mentoring by Industry Experts" },
                    ]
                },
            ]
        };

    }

    render() {
        return (
            <div>
                <Header title={"Engineering Courses"} subTitleText={"This is a program designed to look back at the topics that you learn during the Engineering course work and help get the basics right. The goal of this program is to focus more on the basics of each course and build a overall picture by emphasizing what and why you should learn it the right way. "}/>
                <div className="container">
                    <div className="row">
                        <div className="col-md-8">
                            <h2>Engineering Courses</h2>
                            <hr />
                            <p>As a college student, your number one priority is to learn. What you need to realize early on in your college career is that your learning is not, and should not only be, located in the classroom. </p>
                            <p><strong>LEARN FROM EVERY EXPERIENCE!</strong> Better yet, learn from the successes and failures of others. To do that, you have to be intentional with your experience… and actually have learning experiences.</p>
                            <p>We provide various online courses for engineering students to make them <strong>learn the basics right and have strong expertise in core concepts</strong> for them to build on that foundation and achieve greater success.</p>
                        </div>
                        <div className="col-md-4">
                            <ContactUs />
                        </div>
                    </div>
                </div>
                <hr className="col-md-8" style={{padding: "0px"}}/>
                <div className="container">
                    <CourseSectionHeader title={"Custom Designed Programs"} />
                    <div className="row">
                        { this.loadCourses() }
                    </div>
                </div>
                <hr className="col-md-8" style={{padding: "0px"}}/>
            </div>
        );
    }

    loadCourses() {
        const enroll_base_url = "/enroll";
        return this.state.courses.map((course, id) =>
            <div className="col-md-4 mb-3" key={id}>
                <div className="card h-100">
                    <img className="card-img-top" src={course.imageUrl} alt="" />
                    <div className="card-body">
                        <h4 className="card-title">{course.title}</h4>
                        <h6 className="card-subtitle" style={{color: '#0056b3'}}>{course.subTitle}</h6>
                        <hr />
                        <p className="card-text">{course.description.line1}</p>
                        <p className="card-text">{course.description.line2}</p>
                    </div>
                    <div className="card-footer d-flex justify-content-center">
                        <Link to={{
                            pathname: enroll_base_url + course.enrollmentUrl,
                            state: {
                                course: course,
                                program: this.state.program
                            }
                        }} className="btn btn-info">Enroll Now</Link>
                    </div>
                </div>
            </div>
        );
    }
}

EnggCourses.propTypes = {};

export default EnggCourses;
